const initialState = {
  currentSite: null,
  stats: null,
  baseUrl: null,
  menuConfig: [],
  alerts: [],
  errorPage: null,
  noIndex: false,
  seoMeta: {
    title: 'Envato Market',
    meta_description: 'Over 3 million digital products created by a global community of designers, developers, photographers, illustrators &amp; producers.'
  }
}

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
export default function common (state = initialState, action) {
  let alerts

  switch (action.type) {
    case 'receiveStats':
      return {
        ...state,
        stats: action.payload
      }

    case 'setCurrentSite':
      return {
        ...state,
        currentSite: action.payload
      }

    case 'setBaseUrl':
      return {
        ...state,
        baseUrl: action.payload
      }

    case 'setMenuConfig':
      return {
        ...state,
        menuConfig: action.payload
      }

    case 'showAlert':
      alerts = state.alerts.slice()
      alerts.push(action.payload)
      return {
        ...state,
        alerts
      }

    case 'hideAlert':
      alerts = state.alerts.slice().filter((alert) => {
        return alert.message !== action.payload.message
      })

      return {
        ...state,
        alerts
      }

    case 'resetAlerts':
      return {
        ...state,
        alerts: []
      }

    case 'setErrorPage':
      return {
        ...state,
        errorPage: action.payload.id
      }

    case 'resetErrorPage':
      return {
        ...state,
        errorPage: null
      }

    case 'noIndex':
      return {
        ...state,
        noIndex: true
      }

    case 'setSeoMeta':
      return {
        ...state,
        seoMeta: {
          title: action.payload.title || initialState.seoMeta.title,
          meta_description: action.payload.meta_description || initialState.seoMeta.meta_description
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/common.js